// extracted by mini-css-extract-plugin
export var border = "_5p-0";
export var borderSelected = "_5p-1";
export var check = "_5p-6";
export var circle = "_5p-2";
export var circleInner = "_5p-4";
export var circleInnerDisabled = "_5p-8";
export var description = "_5p-3";
export var horizontal = "_5p-b";
export var input = "_5p-5";
export var label = "_5p-9";
export var radioButton = "_5p-d";
export var radioButtonNoCenter = "_5p-e";
export var radioGroup = "_5p-a";
export var rightRadio = "_5p-f";
export var subcontent = "_5p-g";
export var uncheck = "_5p-7";
export var vertical = "_5p-c";